import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MandatoryAdditionalStyle } from '../../components.utils';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';

const componentConfigurationKey = 'iframe';

interface IframeDataProps {
  html: string;
  dataId?: string;
}

export interface IframeThemeProps {
  backgroundColor: string;
}

type IframeComponentProps = IframeDataProps & MandatoryAdditionalStyle;
export type IframeProps = IframeDataProps & MandatoryAdditionalStyle;


const createIframeWrapperStyle = (backgroundColor: string) => StyleSheet.create({
  style: {
    backgroundColor,
    paddingTop: `calc(100% / (${16 / 9}))`,
    position: 'relative',
  },
});

const createIframeStyle = () => StyleSheet.create({
  style: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
});

const parseIframeHtml = (html: string) => {
  const iframeStyle = createIframeStyle();
  return html
    .replace(/<iframe/, `<iframe class="${css(iframeStyle.style)}"`);
};

export const Iframe: React.FunctionComponent<IframeComponentProps> = props => {
  const { html, additionalStyle, dataId } = props;
  const { backgroundColor } = useTheme<IframeThemeProps>(componentConfigurationKey);
  const iframeWrapperStyle = createIframeWrapperStyle(backgroundColor);
  return (
    <ErrorBoundary>
      <div className={css(additionalStyle.style)}>
        {/* eslint-disable-next-line react/no-danger */}
        <figure data-id={dataId} className={css(iframeWrapperStyle.style)} dangerouslySetInnerHTML={{ __html: parseIframeHtml(html) }} />
      </div>
    </ErrorBoundary>
  );
};
